import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppBaseService } from '@app/shared/services/app-base.service';
import { CrudApiOptions, GenResp } from '@template-ui/services/crud-api.service';
import { map } from 'rxjs';

export interface SeedPhase { code: string; name: string; state: string; message: string; }
export interface SeedRun {
  id: string; requestedByUserId: number; requestedByName: string; requestedAtUtc: string;
  startedAtUtc: string | null; completedAtUtc: string | null; state: string; phases: SeedPhase[]; error: string | null;
}
export interface SeedStatus {
  environment: string; profile: string; available: boolean; unavailableReason: string | null;
  phases: SeedPhase[]; run: SeedRun | null;
}
const headers = new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json',
  'skip-error-interceptor': 'yes', 'skip-loading-interceptor': 'yes' });
const options: Partial<CrudApiOptions<'body', 'json'>> = {
  retries: 0, feedbackOptions: { successMode: 'none', errorMode: 'none' },
  getOptions: { headers, withCredentials: true, responseType: 'json' },
  postOptions: { headers, withCredentials: true, responseType: 'json' },
};
function unwrap<T>(response: GenResp<T> | T | null | undefined): T {
  return response && typeof response === 'object' && 'data' in response ? (response as GenResp<T>).data : response as T;
}
@Injectable({ providedIn: 'root' })
export class EnvironmentSetupService extends AppBaseService {
  status() {
    return this.crudService.getbyUrl<SeedStatus>(this.apis.core.manual.getEnvironmentSeedStatus(), options).pipe(map(unwrap<SeedStatus>));
  }
  start() {
    return this.crudService.postByUrl<SeedRun>(this.apis.core.manual.postEnvironmentSeed(), {}, options).pipe(map(unwrap<SeedRun>));
  }
}
